import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle, FiShare2, FiShield, FiEye } from "react-icons/fi";
import trustHero from "../../../assets/reels_content/fox-mascot.png";

const TrustSection = () => {
  const features = [
    {
      icon: <FiCheckCircle className="w-5 h-5 text-primary" />,
      title: "Expert-Verified Listings",
      body:
        "Access listings backed by industry experts, solving misinformation and enhancing trust.",
    },
    {
      icon: <FiShare2 className="w-5 h-5 text-primary" />,
      title: "Reliable Network Assurance",
      body:
        "Connect with a trusted network of professionals, ensuring peace of mind and reliability.",
    },
    {
      icon: <FiShield className="w-5 h-5 text-primary" />,
      title: "Thorough Testing Guarantee",
      body:
        "Only the best options are presented after thorough testing, addressing quality concerns.",
    },
    {
      icon: <FiEye className="w-5 h-5 text-primary" />,
      title: "Transparent Information Access",
      body:
        "Clear and honest insights into listings help users navigate choices without confusion.",
    },
  ];

  return (
    <section className="bg-white dark:bg-darkbg text-text dark:text-textDark py-16 sm:py-24 transition-colors duration-300">
      <div className="w-full mx-auto max-w-[1400px] 2xl:max-w-[1600px] px-6 xl:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10 items-center">
          {/* Left Column */}
          <div className="text-left">
            <motion.p
              className="text-text/70 dark:text-textDark/70 text-sm font-semibold mb-4"
              initial={{ opacity: 0, y: -8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Reliable Reviews
            </motion.p>

            <motion.h2
              className="font-extrabold tracking-tight text-3xl sm:text-5xl mb-4"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Why you can trust Mr. Reels
            </motion.h2>

            <motion.p
              className="text-text/80 dark:text-textDark/80 mb-10"
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              Our platform transforms user doubts into trust by offering reviews
              verified by experts and clear information, empowering users to
              make confident choices effortlessly.
            </motion.p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-8">
              {features.map((f, i) => (
                <motion.div
                  key={f.title}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.25 }}
                  transition={{ duration: 0.35, delay: i * 0.08 }}
                  className="flex flex-col gap-2 text-left"
                >
                  <div className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-primary/10 border border-border dark:border-borderDark mb-1">
                    {f.icon}
                  </div>
                  <h3 className="font-semibold text-text dark:text-textDark">
                    {f.title}
                  </h3>
                  <p className="text-text/70 dark:text-textDark/70 text-sm leading-relaxed">
                    {f.body}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Right Column - Mascot */}
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.98 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.8 }}
            className="flex justify-center lg:justify-end"
          >
            <div className="relative rounded-2xl overflow-hidden max-w-lg lg:max-w-xl shadow-md">
              <img
                src={trustHero}
                alt="Mr. Reels mascot in casino"
                className="w-[640px] h-auto object-cover rounded-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
